export default __webpack_public_path__ + "static/media/pix2.bf72833b.svg";